/**
 * Created by lotemh on 7/17/2014.
 */
define([
    'santa-components',
    'lodash',
    'reactDOM',
    'skins',
    'wGooglePlusOne/skins/skins.json',
    'componentsCore'
], function (santaComponents, _, ReactDOM, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    function getButtonSize(props) { // eslint-disable-line complexity
        const shouldBeHidden = _.get(props.compProp, 'isHidden');
        const layout = `${props.compProp.size}_none`;
        switch (layout) {
            case 'small_none':
                return {width: 24, height: 15, opacity: shouldBeHidden ? 0 : 1};
            case 'medium_none':
                return {width: 32, height: 20, opacity: shouldBeHidden ? 0 : 1};
            case 'standard_none':
                return {width: 38, height: 24, opacity: shouldBeHidden ? 0 : 1};
            case 'tall_none':
                return {width: 50, height: 20, opacity: shouldBeHidden ? 0 : 1};
            default:
                return {width: 50, height: 20, opacity: shouldBeHidden ? 0 : 1};
        }
    }

    /**
     * @class components.wGooglePlusOne
     * @extends {core.skinBasedComp}
     */
    const wGooglePlusOne = {
        displayName: 'WGooglePlusOne',
        mixins: [componentsCore.mixins.skinBasedComp],
        propTypes: {
            externalScriptLoader: santaComponents.santaTypesDefinitions.SiteAspects.externalScriptLoader.isRequired,
            cookie: santaComponents.santaTypesDefinitions.RequestModel.cookie,
            currentUrl: santaComponents.santaTypesDefinitions.currentUrl,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            userLanguage: santaComponents.santaTypesDefinitions.WixUserSantaTypes.userLanguage.isRequired
        },
        static: {
            useSantaTypes: true
        },

        componentDidMount() {
            this.props.externalScriptLoader.loadScript('GOOGLE', this.renderTag, {
                cookie: this.props.cookie,
                currentUrl: this.props.currentUrl,
                userLanguage: this.props.userLanguage
            });

            if (window.gapi) {
                this.renderTag();
            }
        },
        componentDidUpdate(prevProps) {
            const propNames = ['annotation', 'size'];
            if (!_.isEqual(_.pick(this.props.compProp, propNames), _.pick(prevProps.compProp, propNames))) {
                this.renderTag();
            }
        },

        renderTag() {
            const gPlusRef = this.refs.googlePlus || this.refs[''];
            const buttonSize = getButtonSize(this.props);

            if (_.get(window, 'gapi.plusone')) {// server side rendering fix
                window.gapi.plusone.render(ReactDOM.findDOMNode(gPlusRef), {
                    size: this.props.compProp.size,
                    annotation: this.props.compProp.annotation,
                    width: buttonSize.width
                });
            }
        },

        componentWillUnmount() {
            this.props.externalScriptLoader.unsubscribe('GOOGLE', this.renderTag);
        },
        getSkinProperties() {
            return {
                '': {
                    style: getButtonSize(this.props)
                },
                'googlePlus': {
                    dangerouslySetInnerHTML: {__html: '<div class="g-plusone"></div>'},
                    ref: 'googlePlus'
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.WGooglePlusOne', wGooglePlusOne);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return wGooglePlusOne;
});
